// Importing Components
import { ConditionalComponent } from 'components';

// Importing constant
import CopyIconImg from 'static/images/copy-icon.svg';
import ViewIconImg from 'static/images/view.svg';

// Importing Libraries
import React from 'react';
import PropTypes from 'prop-types';

/**
 * TextCopy Component
 * @param {Object} props - The props object containing label, key, itemCustomClass, and children
 * @param {string} props.label - Label for the text copy component
 * @param {string} props.key - Unique key for the component
 * @param {string} props.itemCustomClass - Custom CSS class for the component
 * @param {*} props.children - Child content to be displayed
 * @returns {JSX.Element} TextCopy component JSX
 */
export const TextCopy = ({ label, key, itemCustomClass, children }) => {
    return (
        <div key={`${key}`} className={`description-item ${itemCustomClass}`}>
            <div className="label">{label}</div>
            <div className="children copy-children">
                {children}
                <span
                    // Copying children text to clipboard on click
                    onClick={() => navigator.clipboard.writeText(children)}
                    className="copy-button "
                >
                    <img src={CopyIconImg} alt="COPY" />{' '}
                </span>
            </div>
        </div>
    );
};

// PropTypes for TextCopy component
TextCopy.propTypes = {
    key: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    itemCustomClass: PropTypes.string,
    children: PropTypes.any,
};

export const DocumentView = ({ label, key, itemCustomClass, children }) => {
    return (
        <div
            key={`${key}`}
            className={`description-item doc-description-item ${itemCustomClass}`}
        >
            <div className="label">{label}</div>
            <div className="children doc-view-child">
                <ConditionalComponent
                    isVisible={children && children.length > 0}
                >
                    {children.map((item, index) => {
                        return (
                            <div key={index} className="doc-container">
                                {item.name}
                                <span
                                    // Copying children text to clipboard on click
                                    onClick={() =>
                                        window.open(item.url, '_blank')
                                    }
                                    className="view-button"
                                >
                                    <img src={ViewIconImg} alt="View" />{' '}
                                </span>
                            </div>
                        );
                    })}
                </ConditionalComponent>
                <ConditionalComponent
                    isVisible={!(children && children.length > 0)}
                >
                    -
                </ConditionalComponent>
            </div>
        </div>
    );
};

// PropTypes for TextCopy component
DocumentView.propTypes = {
    key: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    itemCustomClass: PropTypes.string,
    children: PropTypes.any,
};
